export default class ReferralTO {
  /**
   * @type {string}
  */
  code = '';

  /**
   * @type {string}
  */
  newClientSSN = undefined;

  /**
   * @type {string}
  */
  newClientName = undefined;

  /**
   * @type {boolean}
  */
  bypassVerifications = false;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.code != null) {
        this.code = opts.code;
      }
      if (opts.newClientSSN != null) {
        this.newClientSSN = opts.newClientSSN;
      }
      if (opts.newClientName != null) {
        this.newClientName = opts.newClientName;
      }
      if (opts.bypassVerifications != null) {
        this.bypassVerifications = opts.bypassVerifications;
      }
    }
  }
}
